import { render, staticRenderFns } from "./ModalDialogFrame.vue?vue&type=template&id=03193aac"
import script from "./ModalDialogFrame.vue?vue&type=script&lang=js"
export * from "./ModalDialogFrame.vue?vue&type=script&lang=js"
import style0 from "./css/modalDialogFrame.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports